<template>
 <div class="container">
  <ToastPrime />
  <div class="table-display2">
    <div class="cell-display div2">
      <div class="card">
        <div class="formgrid grid">
          <div class="field col-12 md:col-2 text-left">
            <label for="shipName">{{ $t("shipName") }}</label>
             <p
               id="shipName"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.name }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipIMO">{{ $t("imoNumber") }}</label>
             <p
               id="shipIMO"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.imo }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipType">{{ $t("shipType") }}</label>
             <p
               id="shipType"
               class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.shipType.name }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
            <p
              id="shipGT"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.gt}}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
            <p
              id="shipDWT"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.dwt }}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
            <p
              id="shipTotalDistance"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.totalDistance}}</strong></p>
          </div>
          <div class="field col-12 md:col-2 text-left">
            <label for="iceClass">{{ $t("iceClass") }}</label>
            <p
              id="iceClass"
              class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            ><strong>{{ ship.iceClassType.name}}</strong></p>
          </div>
        </div>

        <div class="formgrid grid">
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-4">
            <FuelConsumptionTable :fuelArray = "fuelConsumptionArray"></FuelConsumptionTable>
          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <!-- Empezamos con los inputs-->

        <div style="display: flex">
          <div style="text-align: left">
            <label for="questionGWPValues">{{ $t("questionGWPValues") }}</label>
            <SelectButton
            id="questionGWPValues"
            name="selectedGWPOPtion"
            v-model="selectedGWPOPtion"
            :options="optionsGWP"
            />
          </div>

          <div v-if="ship.shipType.name === 'LNG Carrier'" style="padding-left: 3%; text-align: left;">
            <p for="motorLNGOptions">{{ $t("inputMotorLNG") }}:</p>
            <DropdownPrime
              id="motorLNGOptions"
              v-model="motorLNGSelected"
              :options="transformedMotorLNGOptions"
              class="field col-4 md:col-12"
            />
          </div>

        </div>
        

        <div class="field col-12 md:col-12 p-2"></div>

        <!--Input para cada año-->
        <div style="display: flex;">
            <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
            <DropdownPrime
            id="yearOptions"
            v-model="yearSelected"
            :options="allYears"
            class="field col-1 md:col-1"
            />
        </div>
        
        <!--PONER TODAS ESTAS VARIABLES DIFERENTES PARA CADA AÑO-->

        <div class="input-box">
          <div v-for="(item, index) in filteredFuelEUVariables" :key="index">
            <div style="display: flex;">

              <div v-if="ship.iceClassType.code != 'NONE'" class="field col-12 md:col-3 text-left">
                  <label for="anualDistanceOnIce">{{ $t("inputAnualDistanceOnIce") }} <strong>(mn)</strong>:</label>
                  <input
                  v-model="item.anualDistanceOnIce"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
              </div>

              <div class="field col-12 md:col-3 text-left">
                  <label for="OPS">OPS <strong>(MJ)</strong>:</label>
                  <input
                  v-model="item.OPS"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
              </div>
              <div class="field col-12 md:col-3 text-left">
                  <label for="windPower">{{ $t("inputWindPower") }} <strong>(Pwind)</strong>:</label>
                  <input
                  v-model="item.windPower"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
              </div>
              <div class="field col-12 md:col-3 text-left">
                  <label for="propulsionPower">{{ $t("inputShipPropulsionPower") }} <strong>(Pprop)</strong>:</label>
                  <input
                  v-model="item.propulsionPower"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
              </div>
            </div>
        
            <!-- En vez de usar un componente, lo hacemos directamente aquí-->
            <div class="field col-12 md:col-10 text-left">
              <table class="styled-table">
                <thead>
                  <tr>
                    <th scope="col">{{ $t("fuelType") }}</th>
                    <th scope="col">{{ $t("anualIceConsumption") }} (M<sub>i, ice</sub>) <strong>(t)</strong></th>
                    <th scope="col">{{ $t("additionalEnergyPercentage") }} <strong>(%)</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(fuel, index) in item.arrayAuxFuelIce" :key="index">
                  <td>
                    {{ fuel.name }}
                  </td>
                  <td>
                      <input v-if="ship.iceClassType.code != 'NONE'" class="input-style" v-model="fuel.anualIceConsumption" type="number" />
                      <p v-if="ship.iceClassType.code == 'NONE'" class="input-style"> {{ fuel.anualIceConsumption }}</p>
                  </td>
                  <td>
                      <p class="input-style"> {{ fuel.additionalEnergyPercentage }}</p>
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="field col-12 md:col-11 text-right">
              <ButtonPrime @click="calcFuelEUValues()" id="add-button" class="button">{{ $t("calculate") }}</ButtonPrime>
            </div>

          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <!--Output para cada año-->
        <!--Tal y como están, se van a sincronizar los desplegables del input y del output -->
        <div style="display: flex;">
            <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
            <DropdownPrime
            id="yearOptions"
            v-model="yearSelected"
            :options="allYears"
            class="field col-1 md:col-1"
            />
        </div>

        <div class="output-box">

          <div v-for="(item, index) in filteredFuelEUVariables" :key="index">
          
            <!--Tres columnas-->
            <div style="display: flex; justify-content: space-around;">
              <!--Primera columna-->
              
             <!--Segunda columna-->
              <div>
                <!--WtT y TtW-->
                <div style="text-align: left; padding-bottom: 15px;">
                  <label for="wellToTank">WtT (Well to Tank) <strong>(gCO<sub>2 eq</sub>/MJ)</strong>:</label>
                  <p
                      id="wellToTank"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ><strong>{{ item.wellToTank }}</strong></p>
                </div>
                <div style="text-align: left;">
                  <label for="tankToWake">TtW (Tank to Wake) <strong>(gCO<sub>2 eq</sub>/MJ)</strong>:</label>
                  <p
                      id="tankToWell"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ><strong>{{ item.tankToWake}}</strong></p>
                </div>
              </div>
              <!--Tercera columna-->
              <div>
                  <!--GHG target y GHG intensity-->
                <div style="text-align: left; padding-bottom: 15px;">
                  <label for="ghgTarget">GHG target <strong>(gCO<sub>2 eq</sub>/MJ)</strong>:</label>
                  <p
                      id="ghgTarget"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ><strong>{{ item.ghgTarget }}</strong></p>
                </div>
                <div style="text-align: left;">
                  <label for="ghgIntensity">GHG intensity <strong>(gCO<sub>2 eq</sub>/MJ)</strong>:</label>
                  <p
                      id="ghgIntensity"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ><strong>{{ item.ghgIntensity }}</strong></p>
                </div>
              </div>
              <!--Cuarta columna-->
              <div style="padding-top: 2%; text-align: left;">
                <label for="complianceBalance">{{ $t("complianceBalance") }}:</label>
                <p
                  id="complianceBalance"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ item.complianceBalance }}</strong></p>
              </div>
              <!--Quinta columna-->
              <div>
                <div style="padding-top: 2%; text-align: left;">
                  <label for="fuelEUPenalty">{{ $t("fuelEUPenalty") }} <strong>(€)</strong>:</label>
                  <p
                    id="fuelEUPenalty"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ><strong>{{ item.fuelEUPenalty.toFixed(0) }}</strong></p>
                </div>
                <div style="display: flex; padding-top: 2%;text-align: left;">
                  <div style="padding-top: 2%; padding-right: 5%;  text-align: left;">
                    <label for="complianceSurplus">Compliance Surplus:</label>
                    <p
                      id="complianceSurplus"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    ><strong>{{ item.complianceSurplus }}</strong></p>
                  </div>

                  <div style="padding-top: 2%; text-align: left;">
                    <label for="complianceDeficit">Compliance Deficit:</label>
                    <p
                      id="complianceDeficit"
                      class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    ><strong>{{ item.complianceDeficit }}</strong></p>
                  </div>

                </div>
              </div>
              
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-12 p-2"></div>
        <div style="padding-left: 70%;">
          <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
          &ensp; &ensp; &ensp; &ensp;
          <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
        </div>

        <!--Párrafos de separación-->
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
        <div class="field col-12 md:col-12 p-2"></div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import utils from "@/utils/configuration/config.js";
import ShipService from "@/services/ShipService";
import ParametricTableService from "@/services/ParametricTableService";
import FuelConsumptionTable from "./FuelConsumptionTable.vue";
import FuelEUService from "@/services/Neobuq/FuelEUService";
import { ToastSeverity } from "primevue/api";

export default{

  components:{
    FuelConsumptionTable
  },

  data(){
    return{
        ship: store.getters.currentShip,
        fuelConsumptionArray : store.getters.currentShip.fuelConsumption,
        actualBaseFuelEU : store.getters.currentShip.baseFuelEU,
        dataForFuelEU : store.getters.currentShip.dataForFuelEU,

        motorLNGOptions : ["LNG Otto (DF medium speed)", "LNG Otto (DF slow speed)", "LNG Diesel (DF slow speed)", "Motores de inyección chispa"],
        motorLNGSelected : { id: "", name: "" },

        optionsBase: ["Yes", "No"],
        optionsGWP: ["RED", "IPCC"],
        selectedGWPOPtion : "RED",

        allYears: ["2023","2024","2025","2026","2027","2028","2029","2030","2031","2032","2033","2034","2035","2036","2037","2038",
        "2039", "2040"],
        yearSelected: "2023",

        //array de datos según el año
        anualFuelEUVariables : []
    }
  },

  created(){
    this.shipService = ShipService.getInstance();
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
    this.fuelEUService = FuelEUService.getInstance();

    //creamos el array de las variables del FuelEU para cada año
    for(let i=0; i< this.allYears.length; i++){
      var aux = {
        year: this.allYears[i], 
        anualDistanceOnIce : 0, 
        OPS: 0, 
        windPower: 0,
        propulsionPower: 0,
        arrayAuxFuelIce : [],
        anualAdjustedConsumption: 0,
        wellToTank : 0,
        tankToWake: 0,
        ghgTarget : 0,
        ghgIntensity : 0,
        complianceBalance : 0,
        fuelEUPenalty: 0,
        complianceSurplus : "0",
        complianceDeficit : "0"
      }

      this.anualFuelEUVariables.push(aux)
    }

    //creamos el array auxiliar para la tabla de inputs
    for(let j=0; j < this.anualFuelEUVariables.length; j++){
      for(let i=0; i< this.ship.fuelConsumption.length; i++){
        var itemAux = {name: this.ship.fuelConsumption[i].fuel.name, anualIceConsumption: 0, additionalEnergyPercentage: 0}
        this.anualFuelEUVariables[j].arrayAuxFuelIce.push(itemAux)
      }
    }

    //ponemos los valores de la BBDD en el array de this.anualFuelEUVariables
    for(let i=0; i< this.actualBaseFuelEU.length; i++){

      //recorremos todo el array this.anualFuelEUVariables buscando el año
      for(let j=0; j < this.anualFuelEUVariables.length; j++){

        if(this.anualFuelEUVariables[j].year == this.actualBaseFuelEU[i].year){
          this.anualFuelEUVariables[j] = {...this.actualBaseFuelEU[i]} //con esto, se me copia bien la distancia de hielo

          if(this.ship.iceClassType.code == 'NONE'){
            
            //Si después de obtener los valores de la BBDD, cambiamos el barco de tipo hielo de NONE a otro, cuando está el otro
            //el this.anualFuelEUVariables[j].arrayAuxFuelIce[k] se quedan a 0 sus valores, no recoge los correctos

            //LO DEJO EN STAND BY, PORQUE SOLO TIENE QUE CAMBIAR 1 INPUT DE CADA COMBUSTIBLE

            for(let k=0; k< this.anualFuelEUVariables[j].arrayAuxFuelIce.length; k++){
              var itemAux2 = {name: this.anualFuelEUVariables[j].arrayAuxFuelIce[k].name, anualIceConsumption: 0, additionalEnergyPercentage: 0}
              this.anualFuelEUVariables[j].arrayAuxFuelIce[k] = itemAux2
            }
            this.anualFuelEUVariables[j].anualDistanceOnIce = 0
          }
        }
      }
    }
    
    //console.log(this.transformedMotorLNGOptions)
    if(this.dataForFuelEU != undefined){
      this.motorLNGSelected = this.dataForFuelEU.motorLNGOPtion
    }
  },
  

  mounted() {
    const parametricTables = ParametricTableService.getInstance().getParametricTable(
      utils.config.firebaseConfig.parametricVersion
    );
    //console.log("parametricTables", parametricTables);
    this.iceClassTypeOptions = parametricTables.iceClassType;
    //console.log("Cargados los tipos de hielo");
  },

  computed:{
    filteredFuelEUVariables() {
      return this.anualFuelEUVariables.filter(item => item.year === this.yearSelected);
    },

    transformedMotorLNGOptions(){
      return this.motorLNGOptions.filter(option => ({ name: option }))
    },
  },

  watch:{
    anualFuelEUVariables:{
      handler(newVal){
        //para cada año
        //console.log("Viejo valor: " + oldVal + " - Nuevo valor: " + newVal)
        newVal.forEach((item) => {
          //para cada combustible
          item.arrayAuxFuelIce.forEach((fuelItem) => {

            //en vez de usar el if, lo calculamos directamente
            var auxTotal = 0
            item.arrayAuxFuelIce.forEach((fuelItem2) => {

              auxTotal = auxTotal + fuelItem2.anualIceConsumption

            })
            //console.log(auxTotal)

            if(auxTotal == 0){
              fuelItem.additionalEnergyPercentage = 0
            }else{
              fuelItem.additionalEnergyPercentage =  (fuelItem.anualIceConsumption / auxTotal).toFixed(3)
            }
          });
        })
        
      

      },
      deep: true 
    }
  },

  methods:{

    calcFuelEUValues(){
      for(let i = 2023; i < 2041; i++){
        //this.ship.fuelEUGWPOPtion = this.selectedGWPOPtion
        this.ship.dataForFuelEU = {GWPOPtion: this.selectedGWPOPtion, motorLNGOPtion: this.motorLNGSelected}
        //this.ship.dataForFuelEU.GWPOPtion = this.selectedGWPOPtion
        //console.log(this.motorLNGSelected)

        for(let i=0; i < this.anualFuelEUVariables.length; i++){

          //if(this.anualFuelEUVariables[i].year == this.yearSelected){

            var itemSelected = this.anualFuelEUVariables[i]
            this.anualFuelEUVariables[i] = this.fuelEUService.calc_fuelEU_values(itemSelected, this.ship, this.ship.dataForFuelEU.GWPOPtion, i)

            //la primera vez que metemos algo
            if(this.actualBaseFuelEU.length == 0){
              this.actualBaseFuelEU.push(this.anualFuelEUVariables[i])
            }else{ 

              //tenemos que comprobar si hemos calculado previamente para ese año, es decir, si está en el array
              var siEsta = false

              //tenemos que recorrer el array de la BBDD, que tiene un tamaño diferente
              for(let j=0; j< this.actualBaseFuelEU.length; j++){
                //si ya hemos introducido datos para ese año, los sobreescribimos
                if(this.actualBaseFuelEU[j].year == this.anualFuelEUVariables[i].year){
                  this.actualBaseFuelEU[j] = this.anualFuelEUVariables[i]
                  siEsta = true
                }
              }

              if(!siEsta){
                //si no existe, lo añadimos
                this.actualBaseFuelEU.push(this.anualFuelEUVariables[i])
              }
            }
          
          //}
        }
      }
    },

    save(){
      //console.log("Guardando FuelEU...")
      // Ordenamos el array de valores del FuelEU por año
      let arrayOrdenado = [...this.ship.baseFuelEU];
      arrayOrdenado.sort((a, b) => a.year - b.year);

      const errorsInSave = this.shipService.saveShip(store.getters.currentShip);

      if (errorsInSave === "") {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: "Datos del FuelEU guardados correctamente",
          life: 1000,
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error guardando los datos:" + errorsInSave,
          life: 5000,
        });
      }
    },
    cancel(){
      //console.log("FuelEUForm-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "neobuqHome" });
    }
  }
}

</script>

<style scoped>

.input-box{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.output-box{
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.button{
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

/*PARA LA TABLA */
.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

.input-style{
    border-radius: 5px;
    height: 40px;
    width: 250px;
}


</style>